import React, { useEffect, useState } from "react";
import "./InquiryForm.css";

export default function InquiryForm({ courses = [], onClose }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === "Escape") {
        onClose?.();
      }
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  function validateForm(formData) {
    const name = (formData.get("FullName") || "").trim();
    const phone = (formData.get("Phone") || "").trim();

    const nameRegex = /^[A-Za-z\s]{3,}$/;
    if (!nameRegex.test(name)) {
      alert("Please enter a valid full name (at least 3 letters).");
      return false;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      alert("Please enter a valid 10-digit phone number.");
      return false;
    }

    return true;
  }

  function Submit(e) {
    e.preventDefault();
    setLoading(true);

    const formEle = e.target;
    const formData = new FormData(formEle);

    if (!validateForm(formData)) {
      setLoading(false);
      return;
    }

    fetch(
      "https://script.google.com/macros/s/AKfycbx6IiE130PDq2nsFQdTgHNGGksfYysguDz4QSe7RWigqU7bcV4CH0zr7kZgZn9rPSEA/exec",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Success:", data);
        alert("Enquiry submitted successfully!");
        formEle.reset();
      })
      .catch((error) => {
        console.error("❌ Error:", error);
        alert("Failed to submit enquiry.");
      })
      .finally(() => setLoading(false));
  }

  return (
    <div className="inquiry-overlay" onClick={() => onClose?.()}>
      <div
        className="inquiry-popup"
        onClick={(e) => e.stopPropagation()} // prevent overlay-close when clicking inside
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          className="close-btn"
          aria-label="Close modal"
          onClick={() => onClose?.()}
        >
          &times;
        </button>

        <h2>Enroll Now</h2>
        <form className="form" onSubmit={Submit} noValidate>
          <input placeholder="Full Name" name="FullName" type="text" required />
          <input placeholder="Phone Number" name="Phone" type="tel" required />
          <select name="Course" required defaultValue="">
            <option value="" disabled>
              Select Course
            </option>
            {courses.map((course, idx) => (
              <option key={idx} value={course}>
                {course}
              </option>
            ))}
          </select>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
